<div class="header-container">
  <div
    class="header-container__header lx-section-title"
    id="modal-basic-title">
    {{ isUpdate ? 'Update' : 'Create' }} Cohort
  </div>
  <div
    class="header-container__close"
    type="button"
    (click)="close()">
    <i class="lx-icon lx-close-x"></i>
  </div>
</div>

<div class="input-container">
  <div class="input">
    <div class="input-container__label lx-label">
      Cohort Name
      <span
        *ngIf="isUpdate === false"
        class="lx-validation-warning">
        *
      </span>
    </div>
    <div
      *ngIf="isUpdate === false"
      class="input-container__name">
      <textarea
        id="cohortName"
        name="cohortName"
        placeholder="Enter cohort name"
        [(ngModel)]="cohort.name"></textarea>
    </div>
    <div *ngIf="isUpdate === true">
      <div class="input-container__name">
        <div class="input-container__label lx-label-bold">
          {{ cohort.name }}
        </div>
      </div>
    </div>
  </div>

  <div class="input">
    <div class="input-container__label lx-label">
      Cohort Description
      <span class="lx-validation-warning">*</span>
    </div>
    <div class="input-container__description">
      <textarea
        id="cohortDescription"
        name="cohortDescription"
        placeholder="Enter cohort description"
        [(ngModel)]="cohort.description"></textarea>
    </div>
  </div>

  <div class="input">
    <div class="input-container__label lx-label">
      Priority
    </div>
    <div class="lx-body">
      Priority serves as a tiebreaker when multiple releases reference the same cohort entity.
    </div>
    <div class="input-container__priority">
      <input
        type="number"
        id="cohortPriority"
        name="cohortPriority"
        min="1"
        max="100"
        placeholder="Enter priority (1-100)"
        [(ngModel)]="cohort.priority" />
    </div>
  </div>

  <div class="line"></div>

  <div class="input">
    <div class="cohort-row inline">
      <div class="input-container__label lx-label">
        Select Entities
        <span class="lx-validation-warning">*</span>
      </div>
      <span
        class="import-bulk"
        id="import-bulk"
        [class.import-bulk--disabled]="isLoadingEntities"
        (click)="openBulkModal()">
        Bulk Import
      </span>
    </div>
    <div
      *ngIf="isLoadingEntities"
      class="entity-load-status lx-body"
      id="entity-load-progress">
      Validating entities... {{ entitiesLoaded | number }} /
      {{ entitiesToLoad | number }}
    </div>
    <div
      *ngIf="!isLoadingEntities && entityLoadFailed"
      class="entity-load-status entity-load-status--error lx-body"
      id="entity-load-error">
      Some entities failed to load. Saving is disabled until they load.
      <button
        class="entity-load-status__retry lx-btn lx-btn-secondary"
        id="retry-entity-load"
        type="button"
        (click)="retryEntityLoad()">
        Retry
      </button>
    </div>
    <dcc-entity-search
      [clearTextOnSelect]="true"
      [entityTypes]="entitySearchTypes"
      (entity)="onEntitySelected($event)"></dcc-entity-search>
  </div>

  <dcc-cohort-entities-details
    *ngIf="unknownEntities.length || entities.length"
    class="create-releases__phase-details"
    header="Entities"
    [enableRemove]="true"
    [entities]="entities"
    [legacyEntities]="unknownEntities"
    (remove)="removeEntity($event)"
    (removeLegacyEntity)="
      removeCohortEntity($event)
    "></dcc-cohort-entities-details>

  <div class="line"></div>
</div>

<div class="footer">
  <button
    class="footer__button-container lx-btn lx-btn-secondary"
    (click)="close()">
    Cancel
  </button>
  <button
    class="footer__button-container lx-btn lx-btn-primary"
    id="save-cohort"
    [disabled]="!canSave"
    (click)="save()">
    {{ isUpdate ? 'Update' : 'Create' }}
  </button>
</div>
